import InviteApplicants from "./InviteApplicantsContainer";

export default InviteApplicants;
